import { jsx as _jsx } from "react/jsx-runtime";
import { darken, lighten, styled } from "@mui/material";
const StyledBadge = styled('span')((props)=>({
        backgroundColor: lighten(props.theme.palette[props.severity].light, 0.9),
        borderRadius: props.theme.spacing(0.5),
        color: darken(props.theme.palette[props.severity].light, 0.6),
        padding: `${props.theme.spacing(0.25)} ${props.theme.spacing(1)}`,
        textTransform: 'uppercase'
    }));
export const StatusBadge = (props)=>/*#__PURE__*/ _jsx(StyledBadge, {
        "data-testid": props['data-testid'],
        severity: props.severity,
        children: props.children
    });
StatusBadge.displayName = 'StatusBadge';

//# sourceMappingURL=StatusBadge.js.map